import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import Box from '../../elements/Box';
import Row from '../../elements/Row';
import Col from '../../elements/Col';
import Icon from '../../elements/Icon';
import Text from '../../elements/Text';

const ContainerErrorAlert = (props) => {
  const {
    row,
    labelKeyTitle,
    labelKeySubTitle,
    labelKeySubTitleIntro,
    tryAgain,
    iconStyles,
    showIcon = true,
    containerSettings,
    showMessage = true
  } = props;
  const { direction, translate, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Row {...row}>
      <Col>
        <Box className={className} style={style} role="alert">
          <Box {...containerSettings}>
            {showIcon && <Icon icon="send" marginRight="2" size={24} {...iconStyles} />}
            {showMessage && (
              <Text type="span">{translate(labelKeyTitle, 'Oops! Something went wrong.')}</Text>
            )}
          </Box>
          <Box tabIndex={0} dataTestId="containerErrorAlert">
            {labelKeySubTitleIntro && <Text>{translate(labelKeySubTitleIntro, 'Please ')}</Text>}
            {labelKeySubTitle && (
              <Text
                padding="0"
                bgColor="transparent"
                borderNone
                onClick={tryAgain}
                onKeyDown={($event) => {
                  if ($event.keyCode === 13) {
                    tryAgain();
                  }
                }}
                className="fr-cmp-location-selector-error-mobile-reload"
              >
                {translate(labelKeySubTitle, 'Try Again')}
              </Text>
            )}
          </Box>
        </Box>
      </Col>
    </Row>
  );
};

ContainerErrorAlert.propTypes = {
  row: PropTypes.objectOf(PropTypes.any),
  iconStyles: PropTypes.objectOf(PropTypes.any),
  labelKeyTitle: PropTypes.string,
  labelKeySubTitle: PropTypes.string,
  labelKeySubTitleIntro: PropTypes.string,
  tryAgain: PropTypes.func
};

ContainerErrorAlert.defaultProps = {
  row: {},
  iconStyles: {},
  labelKeyTitle: 'cmp-location-selector-error-mobile-message',
  labelKeySubTitle: 'cmp-location-selector-error-mobile-reload',
  labelKeySubTitleIntro: undefined,
  tryAgain: () => {},
  containerSettings: {}
};

ContainerErrorAlert.componentName = 'ContainerErrorAlert';
export default ContainerErrorAlert;
